module.exports = __webpack_public_path__ + "1f88ae9aef056480749e30280229cb3d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-17.png
// module id = 2937
// module chunks = 0